<!-- Navbar Header for horizontal only -->
<div class="navbar-header d-none d-lg-flex justify-content-center app-navbar-brand-wrap">
  <a (click)="showMobileMenu = !showMobileMenu" class="nav-toggler waves-effect waves-light d-block d-lg-none"
    href="javascript:void(0)">
    <i [ngClass]="showMobileMenu ? 'ti-close' : 'ti-menu'"></i>
  </a>

  <a class="navbar-brand app-navbar-brand" href="/sales/projects-select">
    <b class="logo-icon">
      <img src="assets/images/logos/solologo-grupo.png" alt="homepagelogo" class="dark-logo" width="44" />
      <img src="assets/images/logos/solologo-grupo.png" alt="homepagelogo" class="light-logo" width="44" />
    </b>
    <span class="logo-text">
      <img src="assets/images/logos/sololetras-grupo.png" alt="homepageletras" class="dark-logo" height="34" />
      <img src="assets/images/logos/sololetras-grupo.png" class="light-logo" alt="homepageletras" height="34" />
    </span>
  </a>

  <a class="topbartoggler d-block d-lg-none waves-effect waves-light" href="javascript:void(0)"
    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent">
    <i class="ti-more"></i>
  </a>
</div>

<ul class="navbar-nav topbar-actions topbar-user-nav ms-auto">
  <li class="nav-item topbar-user" ngbDropdown placement="bottom-end">
    <span class="topbar-role-badge">Afiliaciones</span>

    <a ngbDropdownToggle class="nav-link topbar-avatar-toggle waves-effect waves-dark pro-pic"
      href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <img src="assets/images/users/user4.jpg" alt="user" class="rounded-circle" width="34" height="34" />
    </a>

    <div class="dropdown-menu-end user-dd dropdown-menu-animate-up app-user-dropdown" ngbDropdownMenu>
      <span class="with-arrow">
        <span class="bg-primary"></span>
      </span>
      <div class="app-user-summary">
        <img src="assets/images/users/user4.jpg" alt="user" class="img-circle" width="54" height="54" />
        <div class="min-w-0" *ngIf="user">
          <h4 class="mb-0">{{ user.family_name }} {{ user.given_name }}</h4>
          <p class="mb-0">{{ user.email }}</p>
        </div>
      </div>

      <button type="button" class="dropdown-item app-dropdown-action" (click)="resetPassword('md')">
        <i class="ti-key me-2"></i>Cambiar Clave
      </button>
      <div class="dropdown-divider"></div>
      <button type="button" class="dropdown-item app-dropdown-action" (click)="logout()">
        <i class="fa fa-power-off me-2"></i>Logout
      </button>
    </div>
  </li>
</ul>
